import React from 'react';
import { FiX } from 'react-icons/fi';
import './TermsModal.css';

const TERMS_CONTENT = [
  'Entry only with a valid ticket. Tickets are non-refundable and non-transferable.',
  'Park timings may change without prior notice.',
  'Follow ride safety rules. Height, age, and health restrictions apply.',
  'Children ABOVE 3 years must be accompanied by an adult.',
  'Management is not responsible for loss or damage of personal belongings.',
  'Certain rides may close due to weather or maintenance. No refunds in such cases.',
  'Outside food & beverages are not allowed inside the park.',
  'Photography for personal use only. Commercial or drone use needs permission.',
  'Visitors may be photographed for park promotions.',
  'Management reserves the right to refuse entry or remove guests for safety or misconduct.',
  'Please carry a valid ID proof along with you.',
  'No refunds on purchased tickets are possible, even in case of any rescheduling.',
  'Security procedures, including frisking, remain the right of the management.',
  'No dangerous or potentially hazardous objects including but not limited to weapons, knives, guns, fireworks, helmets, laser devices, bottles, musical instruments will be allowed in the venue and may be ejected with or without the owner from the venue.',
  'The sponsors/performers/organizers are not responsible for any injury or damage occurring due to the event. Any claims regarding the same would be settled in courts in Chennai.',
  'People in an inebriated state may not be allowed entry.',
  'Organizers hold the right to deny late entry to the event.',
  'Venue rules apply.',
];

const TermsModal = ({ isOpen, onClose }) => {
  if (!isOpen) return null;

  return (
    <div className="terms-modal-overlay" onClick={onClose}>
      <div className="terms-modal" onClick={(e) => e.stopPropagation()}>
        <div className="terms-modal-header">
          <h2>Terms and Conditions</h2>
          <button className="terms-modal-close" onClick={onClose} aria-label="Close">
            <FiX />
          </button>
        </div>

        <div className="terms-modal-content">
          <ul className="terms-list">
            {TERMS_CONTENT.map((item, index) => (
              <li key={index}>{item}</li>
            ))}
          </ul>
        </div>
      </div>
    </div>
  );
};

export default TermsModal;
